import { makeApiaPoolsModals2 } from '@apia/api';
import { getLabel } from '@apia/util';
import { observer } from 'mobx-react-lite';
import { usePermissionsContext } from '../Permissions';
import { SimpleButton } from '../../forms';

export const PoolModalBtn = observer(() => {
  const context = usePermissionsContext();

  return (
    <SimpleButton
      disabled={context.disabled}
      variant="outline"
      onClick={() => {
        makeApiaPoolsModals2()
          .openModal({
            title: window.LBL_ADD_GROUP,
          })
          .then((selected) => {
            context.onChangePools(
              selected.reduce(
                (acc, c) => {
                  const newItem = {
                    poolId: c.row.id,
                    poolName: String(c.row.cells[0].children),
                    canUpdate: false,
                  };

                  if (!acc.some((c) => c.poolId === newItem.poolId)) {
                    acc.push(newItem);
                  }
                  return acc;
                },
                [...context.permissions.pools],
              ),
            );
          });
      }}
    >
      {getLabel('btnAddPool').text}
    </SimpleButton>
  );
});
